import { Tooltip } from '@silverfort/sf-components';
import React from 'react';
import { format } from 'date-fns';

interface Props {
    lastChanged?: number;
}

const LastChangedColumn: React.FC<Props> = ({ lastChanged }) => {
    return (
        <div className="flex items-center w-full min-h-5">
            {lastChanged && (
                <Tooltip title={lastChanged}>
                    <p className="text-sm truncate text-nowrap">{format(new Date(lastChanged), 'MMM d, yyyy')}</p>
                </Tooltip>
            )}
        </div>
    );
};

export default LastChangedColumn;
